let generateSrcset=(t,e=[])=>{let a=new URL(t.src);return e.filter(e=>e<=t.width).map(e=>(a.searchParams.set("width",e.toString()),a.href+` ${e}w`)).join(", ")},createImageElement=(e,t,a,r)=>{var c=e.preview_image,s=new Image(c.width,c.height);return s.className=t,s.alt=e.alt||r,s.sizes=a,s.src=c.src,s.srcset=generateSrcset(c,[165,360,533,720,940,1066]),s.loading="lazy",s},checkSwatches=()=>{document.querySelectorAll(".js-color-swatches-wrapper").forEach(s=>{s.querySelectorAll(".js-color-swatches input").forEach(e=>{e.addEventListener("click",e=>{let r=s.querySelector(".media--first"),c=s.querySelector(".media--second");var a=s.dataset.product;if(e.currentTarget.checked&&r){s.querySelector(".js-color-swatches-link").setAttribute("href",e.currentTarget.dataset.variantLink),s.querySelector('.card__add-to-cart button[name="add"]')&&(s.querySelector('.card__add-to-cart button[name="add"]').setAttribute("aria-disabled",!1),s.querySelector('.card__add-to-cart button[name="add"] > span')&&(s.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove("hidden"),s.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add("hidden")),s.querySelector('.card__add-to-cart input[name="id"]').value=e.currentTarget.dataset.variantId);let t=e.currentTarget.value;e=window.Shopify.routes.root+`products/${a}.js`;fetch(e).then(e=>{if(e.ok)return e.json();throw new Error("Network response was not ok")}).then(e=>{var a=e.variants.filter(e=>null!=e.featured_media&&e.options.includes(t))[0];if(a){let t=createImageElement(a.featured_media,r.className,r.sizes,e.title);if(t.src!==r.src){let e=!1;c&&new URL(c.src).pathname===new URL(t.src).pathname&&(r.remove(),c.classList.remove("media--second"),c.classList.add("media--first"),e=!0),0==e&&(r.animate([{opacity:1},{opacity:0}],{duration:200,easing:"ease-in",fill:"forwards"}),setTimeout(()=>{r.parentNode.replaceChild(t,r),t.animate([{opacity:0},{opacity:1}],{duration:200,easing:"ease-in",fill:"forwards"}),c&&c.remove()},200))}}}).catch(e=>{console.error("There was a problem with the fetch operation:",e)})}})})})};function colorSwatches(){checkSwatches(),document.addEventListener("shopify:section:load",function(){checkSwatches()})}colorSwatches();
/* let generateSrcset = (t, e = []) => {
    let a = new URL(t.src);
    return e
      .filter((e) => e <= t.width)
      .map(
        (e) => (a.searchParams.set("width", e.toString()), a.href + ` ${e}w`)
      )
      .join(", ");
  },
  createImageElement = (e, t, a, r) => {
    var c = e.preview_image,
      s = new Image(c.width, c.height);
    return (
      (s.className = t),
      (s.alt = e.alt || r),
      (s.sizes = a),
      (s.src = c.src),
      (s.srcset = generateSrcset(c, [165, 360, 533, 720, 940, 1066])),
      (s.loading = "lazy"),
      s
    );
  },
  checkSwatches = () => {
    document.querySelectorAll(".js-color-swatches-wrapper").forEach((s) => {
      s.querySelectorAll(".js-color-swatches label").forEach((e) => {
        e.addEventListener("mouseenter", (event) => {
          let r = s.querySelector(".media--first"),
            c = s.querySelector(".media--second"),
            a = s.dataset.product;

          if (r) {
            const t = e.value;
            const productUrl = `${window.Shopify.routes.root}products/${a}.js`;

            fetch(productUrl)
              .then((res) => {
                if (res.ok) return res.json();
                throw new Error("Network response was not ok");
              })
              .then((product) => {
                const variant = product.variants.find(
                  (v) => v.featured_media && v.options.includes(t)
                );
                console.log('Hovered swatch value:', t);
                console.log('Product:', product);
                console.log('Matched variant:', variant);
              
                if (variant) {
                  const newImage = createImageElement(
                    variant.featured_media,
                    r.className,
                    r.sizes,
                    product.title
                  );
                  console.log('New image element:', newImage);
                  if (newImage.src !== r.src) {
                    let alreadySwapped = false;
                    if (
                      c &&
                      new URL(c.src).pathname === new URL(newImage.src).pathname
                    ) {
                      r.remove();
                      c.classList.remove("media--second");
                      c.classList.add("media--first");
                      alreadySwapped = true;
                    }

                    if (!alreadySwapped) {
                      r.animate([{ opacity: 1 }, { opacity: 0 }], {
                        duration: 200,
                        easing: "ease-in",
                        fill: "forwards",
                      });

                      setTimeout(() => {
                        r.parentNode.replaceChild(newImage, r);
                        newImage.animate([{ opacity: 0 }, { opacity: 1 }], {
                          duration: 200,
                          easing: "ease-in",
                          fill: "forwards",
                        });
                        if (c) c.remove();

                        console.log(
                          `[Swatch Hover] Updated image to variant: ${
                            variant.id
                          } (${variant.title || product.title})`
                        );
                      }, 200);
                    }
                  } else {
                    console.log('Image src is already the same, skipping update');
                  }
                }
              })
              .catch((err) => {
                console.error(
                  "There was a problem with the fetch operation:",
                  err
                );
              });
          }
        });
      });
    });
  };

function colorSwatches() {
  checkSwatches(),
    document.addEventListener("shopify:section:load", function () {
      checkSwatches();
    });
}
colorSwatches(); */
